import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo la guía después de comprar?',
  a: 'Al completar el pago por Mercado Pago, recibís acceso inmediato al material en formato PDF digital. En menos de 5 minutos tenés todo disponible para descargarlo y empezar.'
}, {
  q: '¿Sirve para cualquier carrera?',
  a: 'Sí. Las técnicas de estudio, gestión del estrés y estrategia de examen funcionan para cualquier materia y cualquier carrera: medicina, derecho, ingeniería, administración, psicología, profesorados y más.'
}, {
  q: '¿Sirve si llegué tarde y el parcial es en pocos días?',
  a: 'Exactamente para eso está diseñado. El Bono 3 (Guía de emergencia 48 horas) tiene un cronograma hora por hora para cuando el tiempo ya no alcanza.'
}, {
  q: '¿Los bonos están incluidos en las dos ofertas?',
  a: 'Sí. Los 4 bonos base están incluidos tanto en el Pack Esencial como en el Pack Total. El Pack Total suma 2 bonos adicionales exclusivos.'
}, {
  q: '¿Qué diferencia tiene con videos de YouTube o TikTok?',
  a: 'Los tips sueltos de redes no tienen contexto, no se adaptan a tu carrera y no forman un sistema. Aprobá en serio es una guía completa con estructura, progresión y herramientas aplicables desde el primer día.'
}, {
  q: '¿Por qué elegir el Pack Total y no el Esencial?',
  a: 'El Pack Total incluye los 2 tomos más específicos (Cuando reprobás y Estudio sostenible) y 2 bonos exclusivos (Técnicas por tipo de examen y Estudio en grupo). Es la diferencia entre resolver este parcial y no volver a vivir esta situación nunca más.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas ni formularios.'
}, {
  q: '¿Sirve si ya reprobé antes?',
  a: 'Sí, y el Pack Total tiene un tomo entero dedicado a este momento: el Tomo 7 (Cuando reprobás) tiene el protocolo emocional, el análisis de qué falló y el plan para el recuperatorio.'
}];
export function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);
  return <section className="py-20 px-6 lg:px-8 bg-cream" data-id="element-72">
      <div className="max-w-[800px] mx-auto" data-id="element-73">
        <div className="text-center mb-12" data-id="element-74">
          <p className="text-sm font-bold text-dark/50 uppercase tracking-widest mb-2" data-id="element-75">
            Dudas comunes
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold" data-id="element-76">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-border overflow-hidden" data-id="element-78">
              <button onClick={() => setOpenId(openId === idx ? null : idx)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-79">
                <span className="font-bold text-lg pr-8" data-id="element-80">{faq.q}</span>
                <ChevronDown className={`shrink-0 transition-transform duration-300 ${openId === idx ? 'rotate-180 text-salmon' : 'text-dark/40'}`} data-id="element-81" />
              </button>

              <AnimatePresence data-id="element-82">
                {openId === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-83">
                    <div className="px-6 pb-6 pt-2 text-dark/80 leading-relaxed" data-id="element-84">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}